import { render } from "./ClientMonitoringRules.vue?vue&type=template&id=8545cd2a"
import script from "./ClientMonitoringRules.vue?vue&type=script&lang=js"
export * from "./ClientMonitoringRules.vue?vue&type=script&lang=js"

import exportComponent from "/Users/Saad/Documents/GitHub/link-portal/link/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__